var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Typography, stackClasses, styled } from '@mui/material';
import { useMemo } from 'react';
import { StatusPermission } from '../../../enum';
import { useTerminologyTranslation } from '../../app/terminology';
import { BasePanel } from '../common/basePanel';
import { LocationSingleFieldTable } from '../common/locationSingleFieldTable';
import { LocationTable } from '../locationTable';
import { QueueStatusType } from '../queue/types';
import { useEffectiveCapacityPermission, useIsPlanLocked, usePlanType } from '../selectors';
var StyledBasePanel = styled(Box)(function () {
  var _a;
  return _a = {}, _a[".".concat(stackClasses.root, " > .").concat(stackClasses.root, "  > :last-child")] = {
    flexShrink: 0.25
  }, _a;
});
var OvertimeCostDetails = function () {
  var t = useTerminologyTranslation('wizard', {
    keyPrefix: 'financial'
  }).t;
  var capacityPermission = useEffectiveCapacityPermission();
  var isPlanLocked = useIsPlanLocked();
  var disabled = capacityPermission !== StatusPermission.Edit || isPlanLocked;
  var extraColumns = useMemo(function () {
    return [{
      name: 'multiplier',
      label: t('multiplier'),
      decimal: 2,
      max: 5,
      placeholder: '1',
      disabled: disabled
    }];
  }, [t, disabled]);
  return _jsx(LocationTable, {
    name: "rate",
    addColumns: ['Average'],
    decimal: 2,
    max: 99.99,
    min: 0,
    suffix: "%",
    defaultValue: 0,
    extraColumns: extraColumns,
    showGroupHeader: true
  });
};
export var OvertimeCostContent = function (_a) {
  var disableDescription = _a.disableDescription;
  var t = useTerminologyTranslation('wizard', {
    keyPrefix: 'financial'
  }).t;
  var capacityPermission = useEffectiveCapacityPermission();
  var isPlanLocked = useIsPlanLocked();
  var disabled = capacityPermission !== StatusPermission.Edit || isPlanLocked;
  return _jsxs(_Fragment, {
    children: [_jsx(OvertimeCostDetails, {}), _jsxs(Box, __assign({
      sx: {
        mt: 8
      }
    }, {
      children: [_jsx(Typography, __assign({
        variant: "subtitle1",
        gutterBottom: true,
        sx: {
          mb: 2
        }
      }, {
        children: t('trainingLengthTitle')
      })), !disableDescription && _jsx(Typography, __assign({
        variant: "body1",
        gutterBottom: true,
        paddingBottom: 2
      }, {
        children: t('trainingLengthDescription')
      })), _jsx(LocationSingleFieldTable, {
        name: "trainWeeks",
        columnLabel: t('trainingLength'),
        disabled: disabled,
        max: 24,
        placeholder: "8"
      })]
    }))]
  });
};
export var OvertimeCost = function () {
  var t = useTerminologyTranslation(['wizard', 'translation']).t;
  var planType = usePlanType();
  var description = "".concat(t('financial.overtimeCostsDescription', {
    planType: planType
  }), " ").concat(t('financial.multiplierDescription'));
  return _jsx(StyledBasePanel, {
    children: _jsx(BasePanel, __assign({
      title: t('financial.overtimeCosts'),
      longDescription: description,
      statusType: QueueStatusType.Rate,
      needSaveBeforeCopy: true
    }, {
      children: _jsx(OvertimeCostContent, {})
    }))
  });
};